var map = {
	"./DIgoOiP2R7I2AReyJR4WS/fonts.css": [
		"./src/components/ElementControlPanel/FontPicker/project/DIgoOiP2R7I2AReyJR4WS/fonts.css",
		23
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/components/ElementControlPanel/FontPicker/project lazy recursive ^\\.\\/.*\\/fonts\\.css$";
module.exports = webpackAsyncContext;